<script setup lang="ts">
import { useStringFunctions } from '@apparatix/composables';
import { Typography, type TypographyVariant } from '@apparatix/library/core';

type Props = {
  email: string,
  name?: string,
  nameVariant?: TypographyVariant,
  emailVariant?: TypographyVariant,
  multilineOnMobile?: boolean,
};

const props = withDefaults(defineProps<Props>(), {
  name: undefined,
  nameVariant: 'section-subheading',
  emailVariant: 'small-body',
  multilineOnMobile: true,
});

const { isEmptyString } = useStringFunctions();
</script>
<template>
  <div class="flex gap-1" :class="{'flex-col lg:flex-row lg:items-center': props.multilineOnMobile, 'items-center': !props.multilineOnMobile}">
    <template v-if="!isEmptyString(props.name, true) && props.name !== props.email">
      <Typography :variant="props.nameVariant" class="leading-none">
        {{ props.name }}
      </Typography>
      <Typography :variant="props.emailVariant" class="leading-none" muted>
        ({{ props.email }})
      </Typography>
    </template>
    <Typography v-else class="leading-none" :variant="props.nameVariant">
      {{ props.email }}
    </Typography>
  </div>
</template>
